import { blipAccountToggleDefaultValue, personalTenantEnabled } from 'app.constants';
export class AccountFeatures {
    static isBlipAccountEnabled() {
        return blipAccountToggleDefaultValue === 'true';
    }
    static isPersonalTenantEnabled() {
        return personalTenantEnabled.toLowerCase() === 'true';
    }
}
